import { CSP_NONCE, Inject, Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import { environment } from 'src/environments/environment';
import { first, timer } from 'rxjs';
import { OnFinish } from 'src/app/rokezzz/api/api/on-finish';
import { RokezzzWindowService } from 'src/app/rokezzz/window/services/window.service';
import { RokezzzPlatformService } from 'src/app/rokezzz/platform/services/platform.service';
import { coreConfig } from 'src/app/core/models/core-config';

@Injectable({
    providedIn: 'root'
})
export class RokezzzGaService {
    private readonly gaApiKey: string = environment.gaApiKey;

    private gtagLoaded: boolean = false;
    private gtagLoading: boolean = false;
    private renderer: Renderer2;
    private document: Document;

    public constructor(
        @Inject(CSP_NONCE) private readonly cspNonce: string,
        private readonly rokezzzWindowService: RokezzzWindowService,
        private readonly rokezzzPlatformService: RokezzzPlatformService,
        private readonly rendererFactory: RendererFactory2,
    ) {
        this.renderer = rendererFactory.createRenderer(null, null);
        this.document = this.rokezzzWindowService.getDocument();
    }

    public async init(): Promise<void> {
        this.sendToAnalytics(
            (): void => { }
        );
    }

    private sendToAnalytics(onFinish: OnFinish<void>, delay: number = coreConfig.externalScriptLoadDelay): void {
        if (this.rokezzzPlatformService.isPlatformServer()) {
            return;
        }

        if (this.gtagLoaded) {
            onFinish();

            return;
        }

        if (this.gtagLoading) {
            timer(1000).pipe(first()).subscribe(() => this.sendToAnalytics(onFinish));

            return;
        }

        this.gtagLoading = true;

        timer(delay).pipe(
            first()
        ).subscribe(() => {
            const mainScriptElement: HTMLScriptElement = this.renderer.createElement('script') as HTMLScriptElement,
                scriptElement: HTMLElement = this.renderer.createElement('script'),
                inlineScript = this.renderer.createText(`window.dataLayer = window.dataLayer || []; function gtag(){dataLayer.push(arguments);} gtag('js', new Date()); gtag('config', '${environment.gaApiKey}');`);

            mainScriptElement.nonce = this.cspNonce;
            mainScriptElement.src = `https://www.googletagmanager.com/gtag/js?id=${this.gaApiKey}`;
            mainScriptElement.async = true;
            scriptElement.nonce = this.cspNonce;
            this.renderer.appendChild(this.document.head, mainScriptElement);
            this.renderer.appendChild(scriptElement, inlineScript);
            this.renderer.appendChild(this.document.head, scriptElement);
            this.gtagLoaded = true;
        });
    }
}
